import { useQuery } from '@tanstack/react-query';
import { fetchAddonApps } from '../api';

export const addonAppsKeys = {
  all: ['addonApps'] as const,
};

interface UseAddonAppsOptions {
  isEnabled?: boolean;
}

// Addon apps change rarely, so they are cached as long as the device models list
export function useAddonApps({ isEnabled = true }: UseAddonAppsOptions = {}) {
  return useQuery({
    queryKey: addonAppsKeys.all,
    queryFn: fetchAddonApps,
    enabled: isEnabled,
    staleTime: 10 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
  });
}
